import { createGlobalStyle } from "styled-components";

export const MsGlobalStyles = createGlobalStyle``;
